<div class="control product-chooser">
  <mat-form-field [style.width]="'100%'" appearance="outline">
    <mat-select [(ngModel)]="selectedValue"
      panelClass="pap-mat-primary pc-overlay"
      (selectionChange)="setCurrentProduct($event.value)"
      #productChooser
      >
      @if (selectedValue) {
        <mat-select-trigger>
          <div class="option-name-price"
            [ngClass]="{'disabled': !selectedValue.inStock}">
            @if (!selectedValue.iconURL) {
              <span class="name">
                {{ selectedValue.shortName }}
              </span>
            }
            @if (selectedValue.iconURL) {
              <span class="name">
                {{ selectedValue.extraShortName }}
                <img class="icon" src="{{ selectedValue.iconURL }}">
              </span>
            }
            <span class="price">
              <price-display [price]="selectedValue.price"
                [quantity]="1">
              </price-display>
            </span>
          </div>
        </mat-select-trigger>
      }
      <div class="product-chooser-title">
        {{ 'i18n.toolbox.productChooser.title' | translate }}
      </div>
      @for (option of options; track trackById($index, option)) {
        <mat-option [ngClass]='["product-chooser-option"]'
          [value]="option"
          [disabled]="!option.inStock">
          <div class="option-name-price overlay"
            [ngClass]="{'disabled': !option.inStock}">
            @if (!option.iconURL) {
              <span class="name">
                {{ option.shortName }}
              </span>
            }
            @if (option.iconURL) {
              <span class="name">
                {{ option.extraShortName }}
                <img class="icon" src="{{ option.iconURL }}">
              </span>
            }
            <span class="price">
              <price-display [price]="option.price"
                [quantity]="1">
              </price-display>
            </span>
          </div>
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
